const TITLE_BY_TYPE: Record<string, string> = {
  APPROVAL_NEEDED: '🔔 New ticket pending approval',
  TICKET_CREATED: '🎫 New ticket created',
  TICKET_APPROVED: '✅ Ticket approved',
  TICKET_REJECTED: '❌ Ticket rejected',
  TICKET_ASSIGNED: '📌 Ticket assigned to you',
  TICKET_UPDATED: '🔄 Ticket updated',
  TICKET_RESOLVED: '✅ Ticket resolved',
  USER_CREATED: '👤 New user',
  USER_UPDATED: '👤 User updated',
  MESSAGE_RECEIVED: '💬 New message',
    PROJECT_MENTION: 'Uptimio Projects',
  PROJECT_TASK_UPDATED: 'Uptimio Projects',
  DEAL_CREATED: 'Uptimio Deal',
  DEAL_UPDATED: 'Uptimio Deal',
  DEAL_DELETED: 'Uptimio Deal',
  INVOICE_CREATED: 'New invoice',
  INVOICE_PAID: 'Invoice paid'
};

const MESSAGE_REPLACEMENTS: Array<[RegExp, string]> = [
  [/je kreirao tiket:/g, 'created ticket:'],
  [/Vaš tiket "/g, 'Your ticket "'],
  [/je odobren i prosleđen tehničkoj podršci/g, 'was approved and sent to technical support'],
  [/CLIENT_ADMIN je odobrio tiket:/g, 'CLIENT_ADMIN approved ticket:'],
  [/je odbijen\. Razlog:/g, 'was rejected. Reason:'],
  [/vam je dodeljen/g, 'has been assigned to you'],
  [/je označen kao rešen/g, 'has been marked as resolved'],
  [/Vaš nalog je kreiran\. Možete se prijaviti sa svojim email-om\./g, 'Your account has been created. You can sign in with your email.'],
  [/Korisnik (.+) je dodat u kompaniju/g, 'User $1 was added to the company']
];

export const localizeNotification = (notification: {
  type?: string;
  title?: string;
  message?: string;
}): { title: string; message: string } => {
  let title = TITLE_BY_TYPE[notification.type || ''] || notification.title || '';
  let message = notification.message || '';

  MESSAGE_REPLACEMENTS.forEach(([pattern, replacement]) => {
    title = title.replace(pattern, replacement);
    message = message.replace(pattern, replacement);
  });

  if (notification.type === 'USER_CREATED' && /account has been created|nalog je kreiran/i.test(message)) {
    title = '👋 Welcome!';
  }

  return { title, message };
};
